import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/shared/Button.styled';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading3 } from 'components/shared/Typography.styled';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledCta } from './BlogFloatingCta.styled';

const SESSION_HIDE_BLOG_FLOATING_CTA = 'SESSION_HIDE_BLOG_FLOATING_CTA';

const BlogFloatingCta: React.FC = () => {
  const { t } = useI18n('blog');
  const { locale } = useRouter();
  const { user, loadingUser } = useContext(LoggedUserContext);

  const [isBannerClosed, setIsBannerClosed] = useState(false);

  function closeBanner(): void {
    setIsBannerClosed(true);
    window?.sessionStorage?.setItem(SESSION_HIDE_BLOG_FLOATING_CTA, 'true');
  }

  useEffect(() => {
    setIsBannerClosed(
      window?.sessionStorage?.getItem(SESSION_HIDE_BLOG_FLOATING_CTA) === 'true'
    );
  }, []);

  return (
    <>
      {!isBannerClosed && !user && !loadingUser && (
        <StyledCta role="complementary" aria-live="polite">
          <Button
            variant="tertiary"
            sizes="sm"
            isIcon
            onClick={closeBanner}
            aria-label={t('floatingCTA.close')}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <Heading3 editorial as="p">
            {t('floatingCTA.title')}
          </Heading3>
          <p>{t('floatingCTA.desc')}</p>
          <Link
            href={`${getAppUrl(
              APP_URLS.join,
              locale
            )}?locale=${locale}&source=floating-blog`}
            passHref
          >
            <ButtonLink
              variant="brandTalent"
              sizes="md"
              onClick={(e) =>
                ServiceEventTracking.trackExternalLandingCtaClicked(
                  e,
                  `${getAppUrl(
                    APP_URLS.join,
                    locale
                  )}?locale=${locale}&source=floating-blog`,
                  'floating-blog'
                )
              }
            >
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('floatingCTA.cta')}</span>
            </ButtonLink>
          </Link>
        </StyledCta>
      )}
    </>
  );
};

export default BlogFloatingCta;
